<template>
  <div class="container">
    <div class="login">
      <div class="welcome">
        <div class="welcome-text">
          <span>欢迎登录</span>
        </div>
      </div>
      <div class="login-form">
        <van-form @submit="onSubmit">
          <van-field
            v-model="nickname"
            type="tel"
            placeholder="请输入手机号"
            maxlength="11"
            class="custom-field"
            :border="false"
            style="background: #F6F6F6; border-radius: 2rem; margin-bottom: 1rem; padding: 0.8rem 1.2rem;"
          >
            <template #left-icon>
              <van-icon name="phone-o" style="font-size: 1.2rem; color: #999; margin-right: 0.5rem;" />
            </template>
          </van-field>
          
          <van-field
            type="digit"
            v-model="smsCode"
            placeholder="请输入验证码"
            maxlength="6"
            class="custom-field"
            :border="false"
            style="background: #F6F6F6; border-radius: 2rem; margin-bottom: 1rem; padding: 0.8rem 1.2rem;"
          >
            <template #left-icon>
              <van-icon name="shield-o" style="font-size: 1.2rem; color: #999; margin-right: 0.5rem;" />
            </template>
            <template #button>
              <div class="code-button" :class="{ 'code-button-disabled': !countdown }" @click="getCode">
                {{ countdown ? text : `${count}秒` }}
              </div>
            </template>
          </van-field>

          <div class="submit-btn" @click="onSubmit">登录</div>

          <div class="agreement">
            <div class="agreement-content" @click="argeeAll = !argeeAll">
              <div class="checkbox-wrapper">
                <div 
                  class="custom-checkbox" 
                  :class="{ 'checked': argeeAll }"
                  style="width: 1.2rem; height: 1.2rem; border-radius: 50%; border: 1px solid #dcdee0; display: flex; align-items: center; justify-content: center; margin-right: 0.5rem; margin-top: 0.1rem;"
                >
                  <van-icon v-if="argeeAll" name="success" style="font-size: 0.8rem; color: #fff;" />
                </div>
              </div>
              <div class="agreement-text">
                <span>勾选即确认已阅读并同意</span>
                <span class="link" @click.stop="agree(1)">《用户协议》</span>
                <span>及</span>
                <span class="link" @click.stop="agree(2)">《用户隐私政策》</span>
                <span>全部内容</span>
              </div>
            </div>
            <div class="agreement-tip">
              <span>若手机号未注册，登录成功后会自动完成注册流程</span>
            </div>
          </div>
        </van-form>
      </div>
    </div>
    <div class="other-login">
      <div class="divider">
        <span class="divider-text">其他登录方式</span>
      </div>
      <div class="social-login">
        <van-image
          class="wechat-icon"
          :src="require('@/assets/images/wechat.png')"
          @click="init"
        />
        <p class="social-text">微信快捷登录</p>
      </div>
    </div>
    <van-overlay :show="show">
      <div class="wrapper">
        <div class="block">
          <van-form @submit="onSubmit2">
            <div class="bind-header">
              <div class="bind-title">绑定手机号</div>
              <div class="bind-subtitle">为了提升您的登录体验，请绑定手机号</div>
            </div>

            <van-field
              v-model="tokenParams.mobile"
              type="tel"
              maxlength="11"
              placeholder="请输入手机号"
              class="custom-field"
              :border="false"
              style="background: #F6F6F6; border-radius: 2rem; margin-bottom: 1rem; padding: 0.8rem 1.2rem;"
            >
              <template #left-icon>
                <van-icon name="phone-o" style="font-size: 1.2rem; color: #999; margin-right: 0.5rem;" />
              </template>
            </van-field>

            <van-field
              type="digit"
              v-model="tokenParams.code"
              maxlength="6"
              placeholder="请输入验证码"
              class="custom-field"
              :border="false"
              style="background: #F6F6F6; border-radius: 2rem; margin-bottom: 1rem; padding: 0.8rem 1.2rem;"
            >
              <template #left-icon>
                <van-icon name="shield-o" style="font-size: 1.2rem; color: #999; margin-right: 0.5rem;" />
              </template>
              <template #button>
                <div class="code-button" :class="{ 'code-button-disabled': !countdown2 }" @click="getCode1">
                  {{ countdown2 ? text2 : `${count}秒` }}
                </div>
              </template>
            </van-field>

            <div class="submit-btn" @click="onSubmit2">确认绑定</div>
          </van-form>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="showPhoneList">
      <div class="wrapper">
        <div class="block">
          <div class="phone-list-header">
            <div class="title">选择登录手机号</div>
            <div class="subtitle">点击下方手机号直接登录</div>
          </div>
          <div class="phone-list">
            <div v-for="(item, index) in mobileList" 
                 :key="index" 
                 class="phone-item" 
                 @click="loginWechat(item.mobile)">
              <div class="phone-number">{{ item.desenMobile }}</div>
              <div class="arrow-icon">
                <van-icon name="arrow" />
              </div>
            </div>
          </div>
          <div v-if="mobileList.length < 3" 
               class="bind-btn" 
               @click="bindPhone">
            <van-icon name="plus" />
            <span>绑定其他手机号</span>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import HeadChild from "../../components/HeadChild";
// 微信授权登录地址
const WX_AUTH_URL = 'https://open.weixin.qq.com/connect/oauth2/authorize?';
// 重定向参数-固定写法
const REDIRECT = '#wechat_redirect';
export default {
  name: "Login",
  props: {},
  data() {
    return {
      argeeAll: false,
      nickname: "",
      digit: "",
      number: "",
      count: "",//60秒倒计时
      text: "获取验证码",
      text2: "获取验证码",
      countdown: true,//验证码的状态，默认显示获取验证码
      countdown2: true,
      // 短信验证码
      smsCode: "",
      // 验证码数据
      code: "",
      // 图片验证码
      // verify: null,
      show: false,
      showPhoneList: false,
      disable:true,//防止多次点击
      params: {
        appid: process.env.VUE_APP_WX_APPID, //测试
        redirect_uri: `${encodeURI(process.env.VUE_APP_WX_BACK + 'Login')}`,
        response_type: 'code', // 固定写法
        scope: 'snsapi_userinfo', // snsapi_base 静默授权获取 open id ；snsapi_userinfo 需要用户授权，获取详细信息
        // state:'STATE', // a-zA-Z0-9的参数值，最多128字节
      },
      tokenParams: {
        code: '',
        openId: '',
        mobile: '',
        unionId: '',
        wxAppId: '',
      },

      mobileList: [],
      code: '', // 微信返回 code
      isLogin: false
    };
  },
  created() {
    // 获取地址参数
    const params = new URLSearchParams(location.search);
    this.code = params.get('code');
    if (this.code) {
      this.initToken()
    }
  },
  components: { HeadChild },
  methods: {
    agree(val) {
      this.$router.push({
        path: "/Agreement",
        query: {
          type: val
        }
      });
    },
    bindPhone() {
      this.show = true
      this.showPhoneList = false
    },
    // 返回
    back() {
      this.$router.back();
    },
    // 表单校验是否通过 通过才触发
    onSubmit() {
  
      let result = this.validatePhoneNumber(this.nickname)
      if (!result) {
        this.$Toast('请输入正确格式手机号');
        return
      }
      if (this.smsCode == '') {
        this.$Toast('验证码不能为空');
        return
      }
      if (!this.argeeAll) {
        this.$Toast('请阅读并同意用户协议');
        return;
      }
      if(!this.disable){
        return
      }
      this.disable =false
      this.$api
        .loginSms(
          this.nickname,
          this.smsCode
        )
        .then((res) => {
          if (res.code == 1) {
            this.disable =true
            this.back()
            this.$Toast(res.msg);
            return
          }
          if (res.user_info.openId) {
            localStorage.setItem("openId", res.user_info.openId);
          } else {
            localStorage.setItem("openId", '');
          }
          this.isLogin = true
          // // 本地储存用户名
          this.$store.commit("setNickname", res.user_info.realName);
          localStorage.setItem("nickname", res.user_info.realName);
          localStorage.setItem("access_token", res.access_token);
          localStorage.setItem("userInfo", JSON.stringify(res.user_info));
          localStorage.setItem('loginphone', this.nickname);
          // 清除预览模式标识
          localStorage.removeItem('isPreviewMode');
          this.back()
        })
        .catch((err) => {
          this.disable =true
          this.$Toast(err.msg);
        });
    },
    validatePhoneNumber(phoneNumber) {
      if (phoneNumber.length !== 11) {
        return false;
      }
      var reg = /^1\d{10}$/;
      return reg.test(phoneNumber);
    },
    onSubmit2() {
      let result = this.validatePhoneNumber(this.tokenParams.mobile)
      if (!result) {
        this.$Toast('请输入正确格式手机号');
        return
      }
      if (this.tokenParams.code == '') {
        this.$Toast('验证码不能为空');
        return
      }
      this.$api
        .bindUserByOpenId(this.tokenParams)
        .then((res) => {
          if (res.code == 0) {
            this.loginWechat(this.tokenParams.mobile)
          } else {
            this.$Toast(res.msg);
          }
        })
        .catch((err) => {
              
          this.$Toast(err);
        });
    },
    getCode1() {
      let result = this.validatePhoneNumber(this.tokenParams.mobile)
      if (!result) {
        this.$Toast('请输入正确格式手机号');
        return
      }
      this.$api
        .sendSms(this.tokenParams.mobile)
        .then((res) => {
          if (res.code == 1) {
            this.back()
            this.$Toast(res.msg);
            return
          }
          this.changeButton1()

        })
        .catch((err) => {
        });
    },
    getCode() {
      let result = this.validatePhoneNumber(this.nickname)
      if (!result) {
        this.$Toast('请输入正确格式手机号');
        return
      }
      this.$api
        .sendSms(this.nickname)
        .then((res) => {
          if (res.code == 1) {
            this.back()
            this.$Toast(res.msg);
            return
          }
          this.changeButton()
        })
        .catch((err) => {
        });
    },
    changeButton1() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.countdown2 = false;
        this.text2 = "重新发送"
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.countdown2 = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    changeButton() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.countdown = false;
        this.text = "重新发送"
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.countdown = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },

    init() {
      if (!this.argeeAll) {
        this.$Toast('请阅读并同意用户协议');
        return;
      }
      // 访问地址
      const access_url = WX_AUTH_URL + `${new URLSearchParams(this.params)}` + REDIRECT;
      // 这些需要判断没有 code 情况拉起授权登录，有就结束放在重复拉起授权登录
      if (!this.code) {
        location.href = access_url;
      }
    },
    initToken() {
      this.$api
        .codeCallback(this.code)
        .then((res) => {
          if (res.code == 0) {
            this.tokenParams.openId = res.data.openid
            this.tokenParams.unionId = res.data.unionid || ''
            this.tokenParams.wxAppId = res.data.appId || process.env.VUE_APP_WX_APPID || ''
            localStorage.setItem("openId", res.data.openid);
            // if (res.data.bindFlag == '0') {  // list.length   >= 5
            //   this.getPhoneList()

            // 
            this.getPhoneList()

          } else {
            this.back()
            this.$Toast(res.msg);
          }

        })
        .catch((err) => {
          this.$Toast(err);
        });
    },
    showDialog() {
      this.$Dialog
        .confirm({
          title: "绑定手机号",
          message: "为了提升您的登录体验，绑定手机号码后即可通过微信快捷登录。",
        })
        .then(() => {
          this.show = true
        })
        .catch(() => {
          this.back()
        });
    },
    getPhoneList() {
      this.$api
        .queryUserMobiles(this.tokenParams.openId)
        .then((res) => {
          if (res.code == 1) {
            this.back()
            this.$Toast(res.msg);
            return
          }
          this.mobileList = res.data
          if (this.mobileList.length > 0) {

            this.showPhoneList = true

          } else {
            this.showDialog()
          }

        })
        .catch((err) => {
          this.$Toast(err.msg);
        });
    },
    loginWechat(mobile) {
      if (this.showPhoneList) {
        this.showPhoneList = false
      }
      this.$api
        .loginWechat(
          this.tokenParams.openId,
          mobile
        )
        .then((res) => {
          if (res.code === 1) {
            this.back()
            this.$Toast(res.msg);
            return
          }
          this.isLogin = true
          // // 本地储存用户名
          this.$store.commit("setNickname", res.user_info.realName);
          localStorage.setItem("nickname", res.user_info.realName);
          localStorage.setItem("access_token", res.access_token);
          localStorage.setItem("userInfo", JSON.stringify(res.user_info));
          localStorage.setItem('loginphone', mobile);
          // 清除预览模式标识
          localStorage.removeItem('isPreviewMode');
          window.history.back();
        })
        .catch((err) => {
          this.$Toast(err.msg);
        });
    },
    goBack() {
      let access_token = localStorage.getItem('access_token')
      if (access_token) {
        window.history.back();
      } else {
        this.closeWXWindow()
      }
    },
    /** 关闭微信浏览器 */
    closeWXWindow() {
      // 微信浏览器里有一个 WeixinJSBridge 对象，就像普通浏览器里必有 window 对象一样，无需额外引入
      // 不过保险起见，还是判断一下是否为空
      if (WeixinJSBridge?.invoke) {
        console.log('微信浏览器')
        WeixinJSBridge.invoke('closeWindow', {}, () => {
        });
      } else {
        window.opener = null;
        window.open("", "_self");
        window.close();
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    console.log('path', to.path)
    if (to.path === '/Agreement') {
      from.meta.keepAlive = true
    } else {
      from.meta.keepAlive = false
    }
    next()
  },
  mounted() {

    if (window.history && window.history.pushState) {
      // 向历史记录中插入了当前页
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.goBack, false);
    }
    let access_token = localStorage.getItem('access_token')
    if (access_token) {
      window.history.back();
    }
    var browserRule = /^.*((iPhone)|(iPad)|(Safari))+.*$/;
    if (browserRule.test(navigator.userAgent)) {
      window.onpageshow = function (event) {
        if (event.persisted) {
          window.location.reload()
        }
      };
    }
  },
  destroyed() {
    window.removeEventListener('popstate', this.goBack, false);
  },
  computed: {},
  watch: {},

};
</script>

<style lang='scss' scoped>
#app {
  height: 100%;
  background-color: white;
}

.container {
  height: 100vh;
  width: 100%;
  font-size: 14px;
  background-color: white;
  background-image: url("../../assets/images/login_bg.svg");
  background-size: cover;
  background-repeat: no-repeat;
  // overflow: hidden;
  display: flex;
  flex-direction: column;
}

.van-cell {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 0.8rem 1.1rem;
  overflow: hidden;
  color: #323233;
  font-size: 1.1rem;
  line-height: 6.4vw;
  background-color: #fff;
}

.login {
  padding-top: 3rem;
  margin-left: 2rem;
  margin-right: 2rem;
  border-radius: 0.5rem;
}

.welcome {
  margin-bottom: 2rem;
  
  .welcome-text {
    font-size: 1.8rem;
    font-weight: 600;
    color: #333;
    margin-top: 0.8rem;
  }
}

.login-form {
  .custom-field {
    transition: all 0.3s;
    
    &:focus-within {
      background: #f0f0f0 !important;
    }
  }
  
  .code-button {
    color: #D59A54;
    font-size: 0.9rem;
    padding: 0 0.5rem;
    transition: all 0.3s;
    
    &:active {
      opacity: 0.8;
    }
    
    &-disabled {
      color: #999;
    }
  }
}

.submit-btn {
  width: 100%;
  height: 2.8rem;
  line-height: 2.8rem;
  text-align: center;
  background: linear-gradient(to right, #ffcf7a, #ffa976);
  color: #fff;
  font-size: 1.1rem;
  border-radius: 1.4rem;
  margin-top: 2rem;
  font-weight: 500;
  transition: all 0.3s;
  
  &:active {
    opacity: 0.9;
    transform: scale(0.98);
  }
}

.agreement {
  margin-top: 1rem;
  
  .agreement-content {
    display: flex;
    align-items: flex-start;
    cursor: pointer;
    transition: all 0.3s;
    
    &:active {
      opacity: 0.8;
    }
    
    .checkbox-wrapper {
      .custom-checkbox {
        transition: all 0.3s;
        
        &.checked {
          background-color: #D59A54;
          border-color: #D59A54;
        }
      }
    }
    
    .agreement-text {
      font-size: 0.8rem;
      color: #666;
      line-height: 1.4;
      flex: 1;
      
      .link {
        color: #D59A54;
        transition: all 0.3s;
        
        &:active {
          opacity: 0.8;
        }
      }
    }
  }
  
  .agreement-tip {
    font-size: 0.8rem;
    color: #999;
    margin-top: 0.5rem;
    padding-left: 1.5rem;
  }
}

.other-login {
  margin-top: 3rem;
  padding: 0 2rem;
  
  .divider {
    position: relative;
    text-align: center;
    margin-bottom: 2rem;
    
    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      width: 30%;
      height: 1px;
      background: #eee;
    }
    
    &::before {
      left: 0;
    }
    
    &::after {
      right: 0;
    }
    
    .divider-text {
      display: inline-block;
      padding: 0 1rem;
      color: #999;
      font-size: 0.9rem;
      background: #fff;
    }
  }
  
  .social-login {
    display: flex;
    flex-direction: column;
    align-items: center;
    
    .wechat-icon {
      width: 3.5rem;
      height: 3.5rem;
      margin-bottom: 0.5rem;
      transition: all 0.3s;
      
      &:active {
        transform: scale(0.95);
      }
    }
    
    .social-text {
      font-size: 0.9rem;
      color: #666;
    }
  }
}

.phone-list-header {
  text-align: center;
  margin-bottom: 1.5rem;
  
  .title {
    font-size: 1.2rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.5rem;
  }
  
  .subtitle {
    font-size: 0.9rem;
    color: #666;
  }
}

.phone-list {
  margin-bottom: 1rem;
}

.phone-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  margin: 0.5rem 0;
  background: #f8f8f8;
  border-radius: 0.5rem;
  transition: all 0.3s;
  
  &:active {
    background: #f0f0f0;
  }
  
  .phone-number {
    font-size: 1.1rem;
    color: #333;
  }
  
  .arrow-icon {
    color: #999;
  }
}

.bind-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  margin-top: 1.5rem;
  padding: 0.8rem 0;
  border-radius: 1.5rem;
  color: #fff;
  background: linear-gradient(to right, #ffcf7a, #ffa976);
  font-size: 1.1rem;
  transition: all 0.3s;
  
  &:active {
    opacity: 0.9;
  }
}

.wrapper {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 100%;
}

.block {
  width: 100%;
  background-color: #fff;
  border-top-right-radius: 1rem;
  border-top-left-radius: 1rem;
  padding: 1.5rem 1.2rem 2rem;
}

.bind-header {
  text-align: center;
  margin-bottom: 2rem;
  
  .bind-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.5rem;
  }
  
  .bind-subtitle {
    font-size: 0.9rem;
    color: #666;
  }
}
</style>